import type { FunctionComponent } from "react";

/** The signed-in home's shape while it loads: its four glass tiles, pulsing. Shown from the first frame for a linked
 *  player (while sign-in resolves, the home's code downloads, and the first games page arrives), so the page never goes
 *  blank or swaps in a spinner first. Its own file: App.tsx renders it before the lazy Home chunk has loaded. */
export const HomeSkeleton: FunctionComponent = () => (
  <main className="mx-auto w-full max-w-[1320px] px-10 pb-10 pt-7 max-[640px]:px-4" aria-busy="true">
    {/* The home's grids (pages/Home.tsx): Mistakes | Openings, then Recent games | Play, stacked under xl. */}
    <div className="grid grid-cols-1 gap-[18px] xl:grid-cols-2">
      {[0, 1].map((i) => <div key={i} className="tile-glass h-[480px] animate-pulse rounded-[14px]" />)}
    </div>
    <div className="mt-[18px] grid grid-cols-1 gap-[18px] xl:grid-cols-[minmax(0,1fr)_340px]">
      <div className="tile-glass h-[550px] animate-pulse rounded-[14px] max-xl:order-last" />
      <div className="tile-glass h-[550px] animate-pulse rounded-[14px] max-xl:h-[300px]" />
    </div>
  </main>
);
